import * as React from 'react';
import { SearchFilterBar } from 'components';
import { IBuildingItem } from 'models';

type FilterKey = 'name' | 'city' | 'state';
type FilterAccumulator = Record<FilterKey, Set<string>>;

interface BuildingSearchProps {
  searchKeyword: string;
  onSearchChange: (value: string) => void;
  filters: Record<string, string>;
  onFiltersChange: (updated: Partial<Record<string, string>>) => void;
  buildings: IBuildingItem[];
  shouldShowFilters?: boolean;
}

export const BuildingSearch = ({
  searchKeyword,
  onSearchChange,
  filters,
  onFiltersChange,
  buildings,
  shouldShowFilters = false,
}: BuildingSearchProps) => {
  const filterFields = Object.entries(
    buildings.reduce<FilterAccumulator>(
      (acc, building) => {
        if (building.account_name) {
          acc.name.add(building.account_name);
        }
        if (building.city) {
          acc.city.add(building.city);
        }
        if (building.state) {
          acc.state.add(building.state);
        }

        return acc;
      },
      {
        name: new Set<string>(),
        city: new Set<string>(),
        state: new Set<string>(),
      },
    ),
  ).map(([key, values]) => ({
    key: key as FilterKey,
    label: key.charAt(0).toUpperCase() + key.slice(1),
    options: Array.from(values),
  }));

  return (
    <SearchFilterBar
      searchValue={searchKeyword}
      onSearchChange={onSearchChange}
      filters={filters}
      onFiltersChange={onFiltersChange}
      filterFields={filterFields}
      shouldShowFilters={shouldShowFilters}
      placeholder="Enter search keyword..."
      label="Building Search"
    />
  );
};
